export { default as EmailDetails } from './email-details';
export * from './email-details';
